import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/prop-types */
import classNames from 'classnames';
import * as React from 'react';
import { useImperativeHandle, useMemo, useRef } from 'react';
import useFocusNew from '../common/effects/useFocusNew';
import { isDark } from '../common/utils';
import { Spinner } from '../spinner/spinner';
import styles from './button.module.scss';
const Button = React.forwardRef((props, ref) => {
    const { border = true, children, disabled = false, focusable = true, type = 'default', label = '', onClick, size = 'sm', style = {}, accent = 'rounded', } = props;
    const isDarkMode = useMemo(() => isDark(), []);
    const buttonClass = useMemo(() => classNames({
        [styles[`default`]]: type === 'progress',
        [styles.no_border]: !border,
        [styles.disabled]: disabled,
        [styles.dark]: isDarkMode,
        [styles[accent]]: true,
    }, [styles[size], styles[type], styles.btn]), [disabled, isDarkMode]);
    // setup for focus
    const buttonRef = useRef(null);
    useImperativeHandle(ref, () => ({
        focus: () => {
            buttonRef.current?.focus();
        },
    }));
    useFocusNew(focusable ? buttonRef : null);
    const focusableProps = useMemo(() => ({
        tabIndex: focusable ? 0 : -1,
    }), []);
    // handler for button click
    const handleClick = () => !disabled && onClick?.();
    const handleKeyUp = (ev) => ev.key === 'Enter' && handleClick();
    return (_jsxs("div", { className: buttonClass, onClick: handleClick, onKeyUp: handleKeyUp, ref: buttonRef, role: "button", style: style, ...focusableProps, "aria-label": label, children: [type === 'progress' && !disabled && (_jsx("span", { className: styles.progress_wrapper, role: "img", children: _jsx(Spinner, {}) })), children && (_jsx("span", { className: styles.icon_container, role: "img", children: children })), label && type !== 'icon' && (_jsx("span", { className: styles.label, children: label }))] }));
});
Button.displayName = 'Button';
export { Button };
